import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios.ts';
import { type QueryConfig } from 'src/lib/react-query.ts';
import { formatResourcePath } from 'src/utils/regex.ts';

import type { ListResponseSmartParkAPI } from 'src/types';

type GuestReason = {
    id: string;
    name: string;
};

const RESOURCE = '/parkings/:parkingId/parking-guest-reason/';

interface DTO {
    parkingId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId }: DTO): Promise<ListResponseSmartParkAPI<GuestReason>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetParkingGuestReasons, RESOURCE as GUEST_REASONS_RESOURCE };
export type { GuestReason };
